import { COOKINBURGER } from '../../constants';
import moment from "moment";

let startDate = moment().tz("Asia/Singapore").subtract(7, 'days').format('YYYY-MM-DD');
let endDate = moment().tz("Asia/Singapore").subtract(1, 'days').format('YYYY-MM-DD');

const initialState  = {
    loading: {
        owner: false,
        scholar: false,
        perOwner: false,
        perOwnerMaxMin: false,
        amuletLending: false,
        deapCheck: false,
        ownerByCountry: false,
        scholarByCountry: false,
        countStatsByOwner: false,
    },
    focusTabIndex: 0,
    dataDeapCheck: {
        amount: 0,
        count: 0,
    },
    dataOwner: {
        total: 0,
        totalPrev: 0,
        new: 0,
        newPrev: 0,
        stop: 0,
        stopPrev: 0,
    },
    dataScholar: {
        total: 0,
        totalPrev: 0,
        new: 0,
        newPrev: 0,
        stop: 0,
        stopPrev: 0,
    },
    dataPerOwner: [],
    dataLendingCount: {
        current: 0,
        prev: 0,
    },
    dataDeapCheckAmount: {
        current: 0,
        prev: 0,
    },
    dataUniqueOwnerCountByDate: {
        date: '-',
        count: 0
    },
    dataUniqueScholarCountByDate: {
        date: '-',
        count: 0
    },
    dataTotalAmuletCountByDate: {
        date: '-',
        count: '-'
    },
    dataTotalDepCountByDate: {
        date: '-',
        count: '-'
    },
    dataTotalScholarDepCountByDate: {
        date: '-',
        count: '-'
    },
    dataOwnerByCountry: [],
    dataScholarByCountry: [],
    dataCountScholarByOwner: [],
    dataCountAmuletByOwner: [],
    dataCountDepByOwner: [],
    dataCountDepByScholar: [],
    dataNumOwner: {
        stop: "-",
        total: "-",
    },
    dataNumScholar: {
        stop: "-",
        total: "-",
    },
    dataTotalDepCount: '-',
};

export default function cookinBurgerScholarReducer(state = initialState, action) {
    switch (action.type) {
        case COOKINBURGER.SET_SCHOLAR_DATA_LOADING:
            return {
                ...state,
                loading: action.payload
            };
        case COOKINBURGER.SET_FOCUS_TAB_INDEX:
            return {
                ...state,
                focusTabIndex: action.payload
            };
        case COOKINBURGER.SET_OVERVIEW_OWNER_DATA_CB:
            return {
                ...state,
                dataOwner: action.payload
            };
        case COOKINBURGER.SET_OVERVIEW_SCHOLAR_DATA_CB:
            return {
                ...state,
                dataScholar: action.payload
            };
        case COOKINBURGER.SET_PER_OWNER_DATA_CB:
            return {
                ...state,
                dataPerOwner: action.payload
            };
        case COOKINBURGER.SET_LENDING_COUNT:
            return {
                ...state,
                dataLendingCount: action.payload
            };
        case COOKINBURGER.SET_DEAP_CHECK_AMOUNT_CB:
            return {
                ...state,
                dataDeapCheckAmount: action.payload
            };
        case COOKINBURGER.SET_UNIQUE_OWNER_COUNT_BY_DATE:
            return {
                ...state,
                dataUniqueOwnerCountByDate: action.payload
            };
        case COOKINBURGER.SET_UNIQUE_SCHOLAR_COUNT_BY_DATE:
            return {
                ...state,
                dataUniqueScholarCountByDate: action.payload
            };
        case COOKINBURGER.SET_OWNER_BY_COUNTRY:
            return {
                ...state,
                dataOwnerByCountry: action.payload
            };
        case COOKINBURGER.SET_SCHOLAR_BY_COUNTRY:
            return {
                ...state,
                dataScholarByCountry: action.payload
            };
        case COOKINBURGER.SET_TOTAL_AMULET_BY_DATE:
            return {
                ...state,
                dataTotalAmuletCountByDate: action.payload
            };
        case COOKINBURGER.SET_TOTAL_DEP_BY_DATE:
            return {
                ...state,
                dataTotalDepCountByDate: action.payload
            };
        case COOKINBURGER.SET_TOTAL_SCHOLAR_DEP_BY_DATE:
            return {
                ...state,
                dataTotalScholarDepCountByDate: action.payload
            };
        case COOKINBURGER.SET_COUNT_SCHOLAR_BY_OWNER:
            return {
                ...state,
                dataCountScholarByOwner: action.payload
            };
        case COOKINBURGER.SET_COUNT_AMULET_BY_OWNER:
            return {
                ...state,
                dataCountAmuletByOwner: action.payload
            };
        case COOKINBURGER.SET_COUNT_DEP_BY_OWNER:
            return {
                ...state,
                dataCountDepByOwner: action.payload
            };
        case COOKINBURGER.SET_COUNT_DEP_BY_SCHOLAR:
            return {
                ...state,
                dataCountDepByScholar: action.payload
            };
        case COOKINBURGER.SET_NUM_OWNER_CB:
            return {
                ...state,
                dataNumOwner: action.payload
            };
        case COOKINBURGER.SET_NUM_SCHOLAR_CB:
            return {
                ...state,
                dataNumScholar: action.payload
            };
        case COOKINBURGER.SET_SCHOLAR_TOTAL_DEP_COUNT_CB:
            return {
                ...state,
                dataTotalDepCount: action.payload
            };
        default:
            return state
    }
}
